import { message } from 'antd';
import { HttpStatusCode } from './constant';
import { buildURL, buildFetchInit, parseResponseData } from './util';
/**
 * @param {RequestOptions} param 接收参数
 * @param {string} [param.path] 请求地址
 * @param {boolean} [autoTip=true] 是否自动提示
 * @return {Promise}
 */

export const doRequest = async (param: RequestOptions, autoTip = true) => {
  if (param.useMock) {
    return {
      code: HttpStatusCode.Success,
      data: param.mockData,
    };
  }
  const url = buildURL(param);
  const fetchInit = buildFetchInit(param);
  try {
    const res = await window.fetch(url, fetchInit);
    const respBody = await parseResponseData(
      res,
      res.headers.get('Content-Type')
    );
    const httpCode: any = respBody.status;
    if (httpCode < 200 || httpCode >= 300) {
      return {
        code: `${httpCode}`,
        message: '网络错误',
      };
    } else {
      if (respBody?.error_response) {
        return {
          code: HttpStatusCode.ServiceException,
          message: respBody?.error_response?.zh_desc,
        };
      }
      return {
        code: HttpStatusCode.Success,
        ...respBody,
      };
    }
  } catch (e) {
    return {
      code: 401,
      message: '登录过期',
    };
    const error: any = e;
    return {
      code: (error && error.code) || HttpStatusCode.ServiceException,
      message: (error && error.message) || '网络错误',
    };
  }
};

const defaultRequestOption: RequestOptions = {
  method: 'POST',
  contentType: 'application/json',
  timeout: 15000,
};

function makeTimeoutPromise(timeout: number) {
  return new Promise((resolve: any, reject: any) => {
    setTimeout(() => {
      resolve({
        code: '3001',
        message: '请求超时',
        requestId: '',
        eventType: '',
        traceId: '',
      });
    }, timeout);
  });
}

/**
 *
 * @param {RequestOptions} opts 请求参数
 * @return {Promise}
 */
export async function request(opts: RequestOptions) {
  const options = Object.assign({}, defaultRequestOption, opts);
  return Promise.race([
    makeTimeoutPromise(options.timeout!),
    doRequest(options),
  ]);
}
